import React from 'react';

const Dashboard: React.FC = () => {
	return <div>Dashboard</div>;
};

export default Dashboard;
